import { useAuthContext } from "../../../context/auth/useAuthContext";
import {
  VulnerabilityJourneyFinishedEventContext,
  useTrackVulnerabilityJourneyFinished,
  useTrackVulnerabilityJourneyOpened,
  useTrackVulnerabilityJourneyStarted,
  vulnerabilityFieldsEntity,
} from "../../../generated/snowplow/trackingEvents";

type useTrackVulnerabilityJourneyHook = {
  trackVulnerabilityJourneyStarted: () => void;
  trackVulnerabilityJourneyOpen: (title: string, step: string) => void;
  trackVulnerabilityJourneyFinished: (
    options: VulnerabilityJourneyFinishedEventContext
  ) => void;
};

const useTrackVulnerabilityJourney = (): useTrackVulnerabilityJourneyHook => {
  const { instigator, sessionId } = useAuthContext();

  const trackVulnerabilityJourneyStarted =
    useTrackVulnerabilityJourneyStarted();
  const trackVulnerabilityJourneyOpen = useTrackVulnerabilityJourneyOpened();
  const trackVulnerabilityJourneyFinished =
    useTrackVulnerabilityJourneyFinished();

  const customerAccountID = instigator?.accountID;
  const customerAccountNo = instigator.accountNumber;

  const contexts = [
    vulnerabilityFieldsEntity({
      id: sessionId,
      account_id: customerAccountID,
      account_number: customerAccountNo,
    }),
  ];

  return {
    trackVulnerabilityJourneyStarted: () => {
      trackVulnerabilityJourneyStarted(undefined, { contexts });
    },
    trackVulnerabilityJourneyOpen: (title: string, step: string) => {
      trackVulnerabilityJourneyOpen({ step, title }, { contexts });
    },
    trackVulnerabilityJourneyFinished: (options) => {
      trackVulnerabilityJourneyFinished(options, { contexts });
    },
  };
};

export default useTrackVulnerabilityJourney;
